// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.complimentaryProductList {
  padding: 0 12px;
  margin-bottom: 8px;
}

.compUpperContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.compProductName {
  font-size: 0.813rem;
  font-weight: 500;
  text-transform: capitalize;
  text-align: left;
  line-height: 1.3;
  margin: 0;
  padding: 0;
  max-width: 100%;
  flex: 0 1 auto;
  min-width: 0;
  word-break: break-word;
}

.compItemNameBadgeCol {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.compItemNameBadgeRow {
  display: flex;
  align-items: center;
  gap: 5px;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
}

.compItemVariantLine {
  font-size: 11px;
  color: #6b7280;
  margin: 0;
  padding: 0;
  line-height: 1.4;
  text-align: start;
  max-width: 100%;
  font-weight: 600;
  word-break: break-all;
}

.compItemAddonLine {
  font-size: 11px;
  color: #717680;
  margin: 0;
  padding: 0;
  line-height: 1.4;
  text-align: start;
  max-width: 100%;
  word-break: break-all;
}

.compFoodTypeContainer {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.compLowerContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.compPriceContainer {
  font-size: 0.875rem;
  font-weight: 600;
}

.compQuantityContainer {
  display: flex;
  padding: 4px 10px;
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  gap: 5px;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
  width: 72px;
  justify-content: space-between;
}

.compQuantityButton {
  border: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  padding: 0;
  cursor: pointer;
  color: #62748e;
}

.compQuantityButton.disabled {
  cursor: not-allowed;
}

.compFormInput {
  border: 0;
  background: transparent;
  min-width: 1ch;
  text-align: center;
  font-size: 0.813rem;
  font-weight: 700;
  color: #8d8787;
  -moz-appearance: textfield;
}

.compFormInput::-webkit-outer-spin-button,
.compFormInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.comp-option-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 4px;
  padding: 0 12px;
}

.comp-kot-text {
  background-color: var(--blue-b4);
  color: var(--blue-b1);
  font-size: 0.813rem;
  padding: 3px 6px;
  border-radius: 4px;
}

.compPrdocutQty {
  font-size: 0.813rem;
  font-weight: 700;
  color: var(--surface-g3);
}

.comp-order-count {
  font-size: 0.813rem;
  font-weight: 500;
  color: #181d27;
}

.comp-upper-boder {
  opacity: 0.3;
}

.allCompMessage {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 24px 12px;
  text-align: center;
}

.allCompMessage p {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  color: #6b7280;
}

.complimentaryProductListContainer {
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}



`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/ComplimentaryProductList/ComplimentaryProductList.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT","sourcesContent":[".complimentaryProductList {\n  padding: 0 12px;\n  margin-bottom: 8px;\n}\n\n.compUpperContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.compProductName {\n  font-size: 0.813rem;\n  font-weight: 500;\n  text-transform: capitalize;\n  text-align: left;\n  line-height: 1.3;\n  margin: 0;\n  padding: 0;\n  max-width: 100%;\n  flex: 0 1 auto;\n  min-width: 0;\n  word-break: break-word;\n}\n\n.compItemNameBadgeCol {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.compItemNameBadgeRow {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  max-width: 100%;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.compItemVariantLine {\n  font-size: 11px;\n  color: #6b7280;\n  margin: 0;\n  padding: 0;\n  line-height: 1.4;\n  text-align: start;\n  max-width: 100%;\n  font-weight: 600;\n  word-break: break-all;\n}\n\n.compItemAddonLine {\n  font-size: 11px;\n  color: #717680;\n  margin: 0;\n  padding: 0;\n  line-height: 1.4;\n  text-align: start;\n  max-width: 100%;\n  word-break: break-all;\n}\n\n.compFoodTypeContainer {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.compLowerContainer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 4px;\n}\n\n.compPriceContainer {\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.compQuantityContainer {\n  display: flex;\n  padding: 4px 10px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 16px;\n  gap: 5px;\n  align-items: center;\n  height: 100%;\n  flex-shrink: 0;\n  width: 72px;\n  justify-content: space-between;\n}\n\n.compQuantityButton {\n  border: 0;\n  background-color: transparent;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 15px;\n  padding: 0;\n  cursor: pointer;\n  color: #62748e;\n}\n\n.compQuantityButton.disabled {\n  cursor: not-allowed;\n}\n\n.compFormInput {\n  border: 0;\n  background: transparent;\n  min-width: 1ch;\n  text-align: center;\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: #8d8787;\n  -moz-appearance: textfield;\n}\n\n.compFormInput::-webkit-outer-spin-button,\n.compFormInput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.comp-option-container {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 4px;\n  padding: 0 12px;\n}\n\n.comp-kot-text {\n  background-color: var(--blue-b4);\n  color: var(--blue-b1);\n  font-size: 0.813rem;\n  padding: 3px 6px;\n  border-radius: 4px;\n}\n\n.compPrdocutQty {\n  font-size: 0.813rem;\n  font-weight: 700;\n  color: var(--surface-g3);\n}\n\n.comp-order-count {\n  font-size: 0.813rem;\n  font-weight: 500;\n  color: #181d27;\n}\n\n.comp-upper-boder {\n  opacity: 0.3;\n}\n\n.allCompMessage {\n  display: flex;\n  flex: 1;\n  justify-content: center;\n  align-items: center;\n  padding: 24px 12px;\n  text-align: center;\n}\n\n.allCompMessage p {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #6b7280;\n}\n\n.complimentaryProductListContainer {\n  padding: 12px 0;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
